import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import {
  Box,
  CircularProgress,
  Divider,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import Image from "next/image";
import { forwardRef } from "react";
import { BsArrowDownUp, BsTrash3Fill } from "react-icons/bs";
import {
  cardType,
  findEventTypeOption,
  getEventImageSrc,
  Translationtype,
} from "utils";
import theme from "../../../apps/dashboard/src/helpers/theme";
import { eventTypeOptions } from "../constants";

interface TransferListItemProps {
  item: cardType;
  style?: React.CSSProperties;
  t: Translationtype;
  loading?: boolean;
  dragHandleListeners?: SyntheticListenerMap;
  listItemClick: (eventType: number) => void;
  deleteCard: (id: string) => void;
}

export const TransferListItem = forwardRef<
  HTMLDivElement,
  TransferListItemProps
>(
  (
    {
      item,
      t,
      loading,
      dragHandleListeners,
      deleteCard,
      listItemClick,
      ...props
    },
    ref
  ) => {
    return (
      <>
        <ListItemButton
          {...props}
          ref={ref}
          role="listitem"
          disableRipple
          onClick={() => listItemClick(item.isDefault ? item.eventType : -1)}
        >
          <div
            {...dragHandleListeners}
            className="cursor-grab px-2"
            onClick={(e) => e.stopPropagation()} // prevent triggering parent
          >
            <BsArrowDownUp className="w-[30px] h-[30px] ml-2 cursor-grab" />
          </div>
          <ListItemText id={item.id} primary={item.questionText} />
          <div>
            <div className="flex flex-col md:flex-row items-center gap-2">
              <div className="flex flex-col items-center">
                <h2 className="text-left font-semibold">
                  {item.isDefault
                    ? t(
                        `Options.event.${findEventTypeOption(
                          item.eventType,
                          eventTypeOptions
                        )}` as any
                      )
                    : t("Options.event.CustomQuestions")}
                </h2>
              </div>

              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    "& .MuiCircularProgress-colorPrimary": {
                      color: theme.colors.purple[950],
                    },
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : null}

              {item.isDefault ? (
                <Image
                  src={getEventImageSrc(item.eventType)}
                  priority
                  width={40}
                  height={40}
                  alt="LOGO"
                />
              ) : null}
              <div
                className="px-2"
                onClick={(event) => event.stopPropagation()}
              >
                <BsTrash3Fill
                  className="w-[30px] h-[30px] text-error ml-2 cursor-pointer"
                  onClick={(event) => {
                    event.stopPropagation();
                    deleteCard(item.id);
                  }}
                />
              </div>
            </div>
          </div>
        </ListItemButton>
        <Divider />
      </>
    );
  }
);

TransferListItem.displayName = "TransferListItem";

export default TransferListItem;
